'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/UserPlus.js";
var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var t = (r, e, o) => e in r ? f(r, e, { enumerable: true, configurable: true, writable: true, value: o }) : r[e] = o, m = (r, e) => {
  for (var o in e || (e = {}))
    c.call(e, o) && t(r, o, e[o]);
  if (s)
    for (var o of s(e))
      l.call(e, o) && t(r, o, e[o]);
  return r;
}, a = (r, e) => i(r, p(e));
const I = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, a(m({ ref: e }, r), { weights: t$1 })));
I.displayName = "UserPlus";
export {
  I as UserPlus
};
